
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4 sm:mb-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-heart-pulse-line text-2xl sm:text-3xl text-white"></i>
              </div>
              <div>
                <div className="text-xs sm:text-sm text-gray-400">株式会社あすなろ</div>
                <div className="text-lg sm:text-xl font-bold leading-tight">訪問ステーション<br />あすなろ</div>
              </div>
            </div>
            <p className="text-base sm:text-lg text-gray-400 leading-relaxed mb-4 sm:mb-6">
              住み慣れた場所で、その人らしく生きることを支援する訪問看護サービスを提供しています。
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">サービス</h3>
            <ul className="space-y-2 sm:space-y-4">
              <li>
                <a href="#services" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">健康状態の観察と助言</a>
              </li>
              <li>
                <a href="#services" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">リハビリテーション</a>
              </li>
              <li>
                <a href="#services" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">医師の指示による医療処置</a>
              </li>
              <li>
                <a href="#services" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">認知症ケア</a>
              </li>
              <li>
                <a href="#services" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">介護予防</a>
              </li>
              <li>
                <a href="#services" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">日常生活の看護</a>
              </li>
              <li>
                <a href="#services" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">ターミナルケア</a>
              </li>
              <li>
                <a href="#services" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">その他のサポート</a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">サポート</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><Link to="/flow" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">ご利用の流れ</Link></li>
              <li><Link to="/pricing" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">料金について</Link></li>
              <li><Link to="/faq" className="text-sm sm:text-lg text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">よくある質問</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">お問い合わせ</h3>
            <p className="text-sm sm:text-lg text-gray-400 mb-4">お気軽にご連絡ください</p>
          </div>
        </div>

        {/* 2事業所の情報 */}
        <div className="mb-8 sm:mb-12 pb-8 sm:pb-12 border-b border-gray-800">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10">
            {/* 本店 */}
            <div className="bg-gray-800/50 rounded-xl sm:rounded-2xl p-6 sm:p-8">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-teal-400">訪問ステーションあすなろ</h3>
              <ul className="space-y-3 sm:space-y-5">
                <li className="flex items-start gap-3 sm:gap-4">
                  <i className="ri-phone-line text-teal-400 text-xl sm:text-2xl mt-1"></i>
                  <div>
                    <p className="text-sm sm:text-base text-gray-400 mb-1">お電話</p>
                    <a href="tel:0463-74-4834" className="text-base sm:text-lg font-semibold hover:text-teal-300 transition-colors cursor-pointer">0463-74-4834</a>
                  </div>
                </li>

                <li className="flex items-start gap-3 sm:gap-4">
                  <i className="ri-mail-line text-teal-400 text-xl sm:text-2xl mt-1"></i>
                  <div>
                    <p className="text-sm sm:text-base text-gray-400 mb-1">メール</p>
                    <a href="/#contact-form" className="text-base sm:text-lg font-semibold break-all hover:text-teal-300 transition-colors cursor-pointer">asunaro.houkan@gmail.com</a>
                  </div>
                </li>

                <li className="flex items-start gap-3 sm:gap-4">
                  <i className="ri-map-pin-line text-teal-400 text-xl sm:text-2xl mt-1"></i>
                  <div>
                    <p className="text-sm sm:text-base text-gray-400 mb-1">所在地</p>
                    <p className="text-base sm:text-lg font-semibold">神奈川県平塚市岡崎2950</p>
                  </div>
                </li>
              </ul>
            </div>

            {/* 支店 */}
            <div className="bg-gray-800/50 rounded-xl sm:rounded-2xl p-6 sm:p-8">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-blue-400">訪問看護ステーションあすなろ伊勢原石田</h3>
              <ul className="space-y-3 sm:space-y-5">
                <li className="flex items-start gap-3 sm:gap-4">
                  <i className="ri-phone-line text-blue-400 text-xl sm:text-2xl mt-1"></i>
                  <div>
                    <p className="text-sm sm:text-base text-gray-400 mb-1">お電話</p>
                    <a href="tel:0463-51-6767" className="text-base sm:text-lg font-semibold hover:text-blue-300 transition-colors cursor-pointer">0463-51-6767</a>
                  </div>
                </li>

                <li className="flex items-start gap-3 sm:gap-4">
                  <i className="ri-mail-line text-blue-400 text-xl sm:text-2xl mt-1"></i>
                  <div>
                    <p className="text-sm sm:text-base text-gray-400 mb-1">メール</p>
                    <a href="/#contact-form" className="text-base sm:text-lg font-semibold break-all hover:text-blue-300 transition-colors cursor-pointer">asunaro.houkan@gmail.com</a>
                  </div>
                </li>

                <li className="flex items-start gap-3 sm:gap-4">
                  <i className="ri-map-pin-line text-blue-400 text-xl sm:text-2xl mt-1"></i>
                  <div>
                    <p className="text-sm sm:text-base text-gray-400 mb-1">所在地</p>
                    <p className="text-base sm:text-lg font-semibold">神奈川県伊勢原市石田829-1 2F</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm sm:text-base text-center md:text-left">
              &copy; 2024 株式会社あすなろ 訪問ステーションあすなろ. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <a href="/privacy" className="text-gray-400 hover:text-teal-400 text-sm sm:text-base transition-colors cursor-pointer">プライバシーポリシー</a>
              <a href="/terms" className="text-gray-400 hover:text-teal-400 text-sm sm:text-base transition-colors cursor-pointer">利用規約</a>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-teal-400 text-sm sm:text-base transition-colors cursor-pointer">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
